import {Moment} from 'moment';
import React from 'react';

import {
  CalendarFilesByDate,
  CalendarInteraction,
  CalendarItem,
  LayeredCalendarItems,
} from 'calendar/CalendarConstants';

import WeekComponent from './WeekComponent';
import WeeklyFileActivity from './WeeklyFileActivity';

interface CalendarWeekProps {
  today: Moment;
  weekStart: Moment;
  interact: CalendarInteraction;
  showWeeklyFileActivity: boolean;
  files: CalendarFilesByDate;
  items: LayeredCalendarItems<CalendarItem>;
}

function CalendarWeek(props: CalendarWeekProps): JSX.Element {
  return (
    <div>
      <WeekComponent
        today={props.today}
        weekStart={props.weekStart}
        items={props.items}
        interact={props.interact}
        renderDate={(date) => <span title={date.format('YYYY-MM-DD')}>{date.format('D')}</span>}
      />
      {props.showWeeklyFileActivity && <WeeklyFileActivity files={props.files} weekStart={props.weekStart} />}
    </div>
  );
}

CalendarWeek.defaultProps = {
  showWeeklyFileActivity: true,
};

export default CalendarWeek;
